import { gql } from '@apollo/client';

/**
 * AOI 编辑面板手动新增关联地址。
 *
 * <p>BFF 内部:
 * <ul>
 *   <li>复用标准化地址平台的 batchSaveAddresses 校验 + 入库 address_core;</li>
 *   <li>把成功的 addressCoreIds 一次性挂到当前 AOI (address_aoi_mapping, match_type=MANUAL).</li>
 * </ul>
 *
 * <p>每条 input 都会在 items 里有一条结果, 调用方按 originalAddress / errorMessage 显示反馈。
 * 单次上限 50 条地址 (跟其他列表型字段一致)。
 */
export const ADD_AOI_RELATED_ADDRESSES = gql`
  mutation AddAoiRelatedAddresses($input: AoiAddRelatedAddressesInput!) {
    addAoiRelatedAddresses(input: $input) {
      totalCount
      successCount
      failedCount
      items {
        originalAddress
        success
        errorMessage
        fullStandardAddress
      }
    }
  }
`;

export interface AoiAddRelatedAddressesInput {
    aoiId: number;
    zipcode: string;
    addressStrings: string[];
}

export interface AoiAddRelatedAddressItem {
    originalAddress: string;
    success: boolean;
    errorMessage: string | null;
    fullStandardAddress: string | null;
}

export interface AoiAddRelatedAddressesResult {
    totalCount: number;
    successCount: number;
    failedCount: number;
    items: AoiAddRelatedAddressItem[];
}

export interface AddAoiRelatedAddressesResponse {
    addAoiRelatedAddresses: AoiAddRelatedAddressesResult;
}
